import Swiper from '../_libs/swiper.esm.browser.bundle'; // quiet

export default class Logos {


	// Constructor
	constructor(element) {

		new Swiper(element.querySelector('.swiper-container'), {
			grabCursor: true,
			loop: true,
			pagination: {
				el: '.swiper-pagination'
			},
			slidesOffsetBefore: 0,
			slidesPerView: 1,
			slideToClickedSlide: false,
			spaceBetween: 0,
			threshold: 1,
			autoplay: {
				delay: 5000,
				disableOnInteraction: true
			}
		});

	}


}
